var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _feFlood3, _feComposite5, _feGaussianBlur3, _feOffset3, _feComposite6, _feFlood4, _feComposite7, _feGaussianBlur4, _feOffset4, _feComposite8, _feColorMatrix, _feFlood5, _feComposite9, _feGaussianBlur5, _feOffset5, _feComposite10, _feFlood6, _feComposite11, _feGaussianBlur6, _feOffset6, _feComposite12, _feColorMatrix2, _feFlood7, _feComposite13, _feGaussianBlur7, _feOffset7, _feComposite14, _feFlood8, _feComposite15, _feGaussianBlur8, _feOffset8, _feComposite16, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimacyKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3805",
    viewBox: "0 0 109.84477 25.789475",
    height: 70,
    width: 194.625,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3800"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter4374",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4374-3",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364-7",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366-5",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368-9",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370-2",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372-2",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4374-9",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4364-73",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4366-6",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4368-1",
    result: "blur",
    stdDeviation: 2,
    in: "composite1"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4370-29",
    result: "offset",
    dy: 0,
    dx: 0
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4372-3",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4830",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood4820",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4822",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur4824",
    result: "blur",
    stdDeviation: 1.8,
    in: "composite1"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset4826",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite4828",
    result: "fbSourceGraphic",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix8694",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha"
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    in: "fbSourceGraphic",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1,
    id: "feFlood8696"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite1",
    operator: "in",
    in: "flood",
    id: "feComposite8698",
    in2: "fbSourceGraphic"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.1,
    in: "composite1",
    id: "feGaussianBlur8700"
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 0,
    dx: 0,
    id: "feOffset8702"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite2",
    operator: "over",
    in: "fbSourceGraphic",
    id: "feComposite8704",
    in2: "offset"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter8848",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood8838",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite8840",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur8842",
    result: "blur",
    stdDeviation: 1,
    in: "composite1"
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset8844",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite8846",
    result: "fbSourceGraphic",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix8874",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha"
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    in: "fbSourceGraphic",
    result: "flood",
    floodColor: "rgb(63,63,63)",
    floodOpacity: 1,
    id: "feFlood8876"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite1",
    operator: "in",
    in: "flood",
    id: "feComposite8878",
    in2: "fbSourceGraphic"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2,
    in: "composite1",
    id: "feGaussianBlur8880"
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: -0.1,
    dx: -0.1,
    id: "feOffset8882"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    result: "composite2",
    operator: "over",
    in: "fbSourceGraphic",
    id: "feComposite8884",
    in2: "offset"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter9033",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood9023",
    result: "flood",
    floodColor: "rgb(63,63,63)",
    floodOpacity: 1
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite9025",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur9027",
    result: "blur",
    stdDeviation: 1,
    in: "composite1"
  })), _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset9029",
    result: "offset",
    dy: -0.1,
    dx: -0.1
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite9031",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "primacy-key-c",
    x1: 2.857738,
    x2: 27.352634,
    y1: 134.72194,
    y2: 134.72194,
    gradientTransform: "matrix(3.8402553,0,0,0.16001063,-2.2527177,-10.106117)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop9261",
    offset: "0%",
    stopColor: "#026892"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9263",
    offset: "34.657%",
    stopColor: "#25B794"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9265",
    offset: "69.207%",
    stopColor: "#F9D954"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9267",
    offset: "99.902%",
    stopColor: "#EA6E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9269",
    offset: "100%",
    stopColor: "#25B794"
  })))), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.8016739,0,0,0.92431133,1.3855763,1.1592453)",
    ry: 1.0085174,
    rx: 0.93072182,
    y: -4.7474341,
    x: 1.4912233,
    height: 34.506004,
    width: 56.989555,
    id: "rect3807",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d5d5d5",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers",
      filter: "url(#filter9033)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0.9198032,
    rx: 1.6545857,
    y: -2.9846764,
    x: 4.6848516,
    height: 31.470686,
    width: 101.31287,
    id: "rect3807-9",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text995-4",
    y: 5.1753807,
    x: 44.254421,
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "28.21594238px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      strokeWidth: 0.7053985
    },
    y: 5.1753807,
    x: 44.254421,
    id: "tspan993-7"
  }, "Primacy")), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#primacy-key-c)",
      fillRule: "evenodd",
      strokeWidth: 0.78388888
    },
    width: 94.066666,
    height: 3.9194443,
    x: 8.7217255,
    y: 9.491106,
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text9333",
    y: 20.829332,
    x: 8.6629906,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "3.76261234px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.56439185
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 500,
      fontStretch: "normal",
      fontSize: "5.26765776px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Medium'",
      strokeWidth: 0.56439185
    },
    y: 20.829332,
    x: 8.6629906,
    id: "tspan9331"
  }, "Low Priority                       High Priority")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimacyKey);
export default __webpack_public_path__ + "static/media/primacy-key.efad26d6d0d3eb03631c8cc8946840be.svg";
export { ForwardRef as ReactComponent };